import React, { cloneElement, Children } from 'react';
import { getAllParams } from '../service/utils';
import useAccessibilityEscapeKey from '../hooks/useAccessibilityEscapeKey';
import PropTypes from 'prop-types';

const AccessibilityPopup = ({ close, children, ...params }) => {
    
    useAccessibilityEscapeKey(close);

    const child = Children.only(children);

    return cloneElement(child, {
        role: 'dialog',
        'aria-modal': 'true',
        tabIndex: '-1',
        ...getAllParams(params)
    });
};

AccessibilityPopup.propTypes = {
    children: PropTypes.element.isRequired
};

export default AccessibilityPopup;
